import React from "react";
import "./Footer.scss";

export default function Footer() {
  return (
    <footer className="site-footer" id="footer">
      <div className="site-width footer-main"><div><p className="eyebrow">HAVE SOMETHING IN MIND?</p><h2>Let’s make it<br /><em>work beautifully.</em></h2></div><a href="mailto:TobiasKlock84@gmail.com" className="footer-cta">Start a conversation <span aria-hidden="true">↗</span></a></div>
      <div className="site-width footer-bottom"><span>© {new Date().getFullYear()} Klock Consulting</span><div><a href="mailto:TobiasKlock84@gmail.com">Email</a><a href="https://www.linkedin.com/in/tobiasklock">LinkedIn</a></div><span>Independent software consulting</span></div>
    </footer>
  );
}
